import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, DynamicVideoCarousel, PopupRegisterForm, Timeline,MediaShowcase,FAQSection } from '../../components/template';

const InnergiseLandingPage = () => {
  const navigate = useNavigate();
    const [showPopup, setShowPopup] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  const videos = [
 

"https://www.youtube.com/embed/m2SIdalmVoE",
     "https://www.youtube.com/embed/HxfZBWREmxY", 
"https://www.youtube.com/embed/L4KTemoIhcg",
 ];
const timeheading = "Your 4-Day Retreat Journey";
const resetHighlights = [
  {
    icon: '🧘‍♂️',
    text: '5 days of deep inner work',
  },
  {
    icon: '📚',
    text: 'Practical tools from timeless Indian wisdom',
  },
  {
    icon: '🤝',
    text: 'A powerful community of growth-seekers',
  },
  {
    icon: '🌿',
    text: 'Nature-led rhythm & nourishing lifestyle',
  },
  {
    icon: '🧠',
    text: 'Personalized insights to understand yourself better',
  },
  {
    icon: '🏡',
    text: 'A clear plan to carry the peace home',
  },
];

const journey = [
  {
    day: "Day 1",
    title: "Ignite Your Energy",
    activities: [
      "🧘‍♂️ Dynamic Hatha Yoga & Breathwork to awaken vitality.",
      "🧠 Mindset Rewiring & Fire Meditation to release limiting beliefs.",
    ],
  },
  {
    day: "Day 2",
    title: "Strengthen Resilience",
    activities: [
      "🌅 Power Yoga & Pranayama to build endurance.",
      "💨 Emotional Resilience & Self-Inquiry to overcome stress & fears.",
    ],
  },
  {
    day: "Day 3",
    title: "Discover Your Purpose",
    activities: [
      "💡 Happiness Psychology & Self-Discovery Journaling for clarity.",
      "🎭 Breakthrough Transformation Activity to unlock hidden potential.",
    ],
  },
  {
    day: "Day 4",
    title: "Integrate & Elevate",
    activities: [
      "🌞 Energy Flow Yoga & Breathwork for alignment.",
      "📝 Purpose Mapping & Gratitude Circle to seal transformation.",
    ],
  },
];
const faqData = [
  {
    question: "Where and when is the Innergise Retreat happening?",
    answer:
      "Join us in a serene Himalayan resort in Rishikesh, 2–5 Oct 2025 — 4 days to realign your mind, body & emotions. Location shared upon registration.",
  },
  {
    question: "What’s the refund policy?",
    answer: `You can cancel your retreat booking by sending a written request to mitra@param.life. The refund amount depends on how far in advance you cancel:\n
45+ days before: 95% refund (5% processing fee applies)\n
44–30 days before: 75% refund\n
29–15 days before: 25% refund\n
14–8 days before: 10% refund\n
Within 7 days: No refund\n
Special consideration may be given for unavoidable reasons with proper documentation. Refunds are processed within 15 days after confirmation.\nRead full policy here.`,
  },
  {
    question: "How much does it cost in total?",
    answer:
      "Regular price: ₹42,499 → Offer Price: ₹23,599 (If you confirm before 31st August)  | Pre-booking: ₹2,499",
  },
  {
    question: "Can I pay in instalments?",
    answer:
      "Yes — Pay ₹2,499 now to reserve your spot, and clear the balance in easy instalments before the retreat.",
  },
  {
    question: "Do you offer group discounts?",
    answer:
      "Yes, special rates are available for groups, for that you need to connect with our team.",
  },
  {
    question: "Is travel included in the price?",
    answer:
      "No — travel to the venue isn’t included, but we’ll guide you on the best routes and help coordinate group travel.",
  },
  {
    question: "What’s a typical day like?",
    answer:
      "Morning yoga & meditation, afternoon workshops & reflection, evening community circles — all balanced with free time to rest and explore.",
  },
  {
    question: "I’m nervous about joining strangers. Will I fit in?",
    answer:
      "Absolutely — our small group and guided activities make it easy to connect.",
  },
  {
    question: "Will there be long hikes or intense physical activity?",
    answer:
      "No — activities are gentle and adaptable to all fitness levels.",
  },
  {
    question: "What kind of rooms are provided?",
    answer: `You can choose from comfortable cottages or Swiss tents, with single or twin-sharing options:\n
Cottage – Single Occupancy\n
Swiss Tent – Single Occupancy\n
Cottage – Twin Sharing\n
Swiss Tent – Twin Sharing\n
All options include cosy bedding, private space, and access to all retreat facilities.`,
  },
  {
    question: "I’ve never done yoga or meditation before. Still, can I join?",
    answer:
      "Absolutely! This retreat is beginner-friendly. You’ll be guided step-by-step — no prior experience is needed.",
  },
  {
    question: "How many people will attend?",
    answer:
      "We keep it intimate with only 20 participants - so everyone gets personal attention.",
  },
  {
    question: "Is this a religious or spiritual retreat?",
    answer:
      "It’s rooted in timeless wellness wisdom but is non-religious and open to all backgrounds.",
  },
  {
    question: "Can I extend my stay before or after the retreat?",
    answer:
      "Yes — just let us know in advance so we can check availability with the venue.",
  },
  {
    question: "Is it suitable for couples or solo?",
    answer:
      "Definitely — the retreat is perfect whether you’re coming alone, with friends, or as a couple.\nSolo travellers get a safe, welcoming space to recharge and connect with like-minded people.\nCouples often attend to strengthen their bond and experience a shared reset.\nFriends enjoy it as a meaningful getaway that’s more than just a trip — it’s a transformation.",
  },
];



      {/* Other page sections go here */}

const BookingCTA = ({ timeLeft, setShowPopup }) => {
  return (
    <div className="mt-10 md:p-5 text-center flex flex-col items-center">
      {/* Offer First */}
            <p className="text-md md:text-lg font-medium text-black mb-3">
        Regular Price: <span className="line-through">₹42,499</span> |
        <span className="font-bold text-secondary">Offer Price: ₹23,599</span>
      </p>
            <p className="text-lg md:text-xl font-semibold text-gray-700 mb-1">
        <span className="font-bold text-xl md:text-2xl text-primary">Get Flat ₹18,900 Off</span>
      </p>

            <p className="text-sm md:text-md mb-5 text-gray-700 font-semibold">
        Reserve  Your Seat in Just Rs.2499/-
      </p>




<div className="w-full flex justify-center mt-4">
  <Button
    text="Book Now"
    variant="primary"
    size="md"
    onClick={() => setShowPopup(true)}
    className="min-w-[320px] md:min-w-[360px]"
  />
</div>


      {/* Countdown Timer */}
<div className="flex space-x-4 mt-6">
  {["Days", "Hours", "Minutes", "Seconds"].map((label, i) => {
    const value = [timeLeft.days, timeLeft.hours, timeLeft.minutes, timeLeft.seconds][i];
    return (
      <div
        key={label}
        className="flex flex-col items-center justify-center min-w-[64px] md:min-w-[72px] bg-[#578d48] rounded-md px-2 py-1 md:px-3 md:py-2 shadow text-white font-bold"
      >
        <span className="text-xl md:text-2xl">{String(value).padStart(2, "0")}</span>
        <span className="text-xs">{label}</span>
      </div>
    );
  })}
</div>

    </div>
  );
};




  useEffect(() => {
    // Fixed reference point — first cycle start (example: Aug 1, 2025 00:00:00)
    const baseTime = new Date("2025-08-06T00:00:00").getTime();
    const cycleDuration = 48 * 60 * 60 * 1000; // 48 hours in ms

    const interval = setInterval(() => {
      const now = new Date().getTime();

      // Find how many full 48-hour cycles have passed
      const cyclesPassed = Math.floor((now - baseTime) / cycleDuration);

      // Calculate the current cycle's end time
      const currentCycleEnd = baseTime + (cyclesPassed + 1) * cycleDuration;

      // Calculate time left
      const distance = currentCycleEnd - now;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setTimeLeft({ days, hours, minutes, seconds });
    }, 1000);

    return () => clearInterval(interval);
  }, []);
  const Highlight = ({ children }) => (
    <span className="text-[#578d48] font-semibold">{children}</span>
  );

 
    const accomodateItems=[
  { type: "image", src: "/assets/synnergise/10.jpg" },
  { type: "image", src: "/assets/innergise/innergise 11.jpg" },
  { type: "image", src: "/assets/synnergise/7.jpg" },
  { type: "image", src: "/assets/synnergise/yog2.jpg" },
  { type: "image", src: "/assets/synnergise/2.jpg" },
  { type: "image", src: "/assets/synnergise/3.jpg" },
];



  const testimonalVideos = [
    'https://www.youtube.com/embed/yz4INHZkJNI', 
    'https://www.youtube.com/embed/0E8hm2fdxCs', 
    'https://www.youtube.com/embed/cHuh-cGuYmg', 
  ];
const retreatGifts = [
  {
    emoji: '🧘‍♂️',
    title: 'Stay & meals',
    value: '₹30,000',
    description: 'A peaceful, all-inclusive stay in the Himalayas – covering accommodation.',
  },
  {
    emoji: '🧠',
    title: 'SAMARA Technique',
    value: '₹2,499',
    description: 'A powerful technique rooted in Vedanta that helps you break limiting mental loops.',
  },
  {
    emoji: '🧘‍♀️',
    title: 'Guided Yoga Sessions',
    value: '₹4,500',
    description: 'Guided Yoga, Breathwork & Yog Nidra Sessions.',
  },
  {
    emoji: '🧬',
    title: 'Prakriti Analysis',
    value: '₹3,500',
    description: 'Discover your unique mind-body type based on ancient Indian science.',
  },
  {
    emoji: '🥗',
    title: 'Detox & Wellness Plan',
    value: '₹2,000',
    description: 'Sattvic meals, daily schedule & wellness routines for rejuvenation.',
  },
];


  return (<div className="bg-white min-h-screen relative ">
<div className="left-0 w-full z-40 bg-secondary text-white text-center font-bold py-4 shadow-md">
  <div className="flex flex-col md:flex-row items-center justify-center gap-2 text-base md:text-xl">
    <span>INNERGISE Retreat</span>
    <span className="hidden md:inline">|</span>
    <span>11–14 OCT 2025&nbsp;|&nbsp;Rishikesh, Himalayas</span>
  </div>
</div>



<div className="bg-white min-h-screen relative px-2 md:px-20">
      {/* FLOATING TOP BAR */}
      {/* MAIN CONTENT */}
  <div className="w-full px-4 md:px-20 text-center pb-3 pt-[3rem] ">
  <h1 className="text-xl md:text-4xl font-bold text-primary leading-snug">
    <span className="block md:inline">
      An Inner Alignment Program In the Tranquil Himalayas
    </span>
    <br className="hidden md:block" />
    <span className="block md:inline">
      To Relax, Recharge, and Rediscover Who You Are
    </span>
  </h1>

  <h2 className="text-sm md:text-xl text-gray-700 mt-8 md:mt-10 leading-relaxed">
    <span className="block md:inline">
      A 4-Day inner journey to rebuild yourself Mentally, Physically, and Emotionally
    </span>
    <br className="hidden md:block" />
    <span className="block md:inline">
      So you can unlock your Clearest, calmest, most powerful version
    </span>
  </h2>
</div>


    <div className="w-full flex flex-col items-center bg-white px-4 md:px-8 py-8">
      {/* Video */}
      <DynamicVideoCarousel videos={videos} heading=""  />

      <BookingCTA timeLeft={timeLeft} setShowPopup={setShowPopup} />


{/* Registration Popup */}
{showPopup && <PopupRegisterForm onClose={() => setShowPopup(false)} />}
    </div>


    <div className="w-full bg-white py-2 md:py-10 px-4 md:px-8 flex justify-center">
      <div className="md:rounded-3xl bg-light shadow-lg max-w-6xl w-full flex flex-col md:flex-row overflow-hidden">
        
        {/* Image Left */}
<div className="md:w-2/3 w-full p-4 md:p-6">
  <img
    src="/assets/gp1.jpg"
    alt="Gaurv Parmarthy"
    className="object-cover w-full h-60 md:h-full rounded-xl md:rounded-none"
  />
</div>

        {/* Text Right */}
        <div className="md:w-2/3 w-full p-6 md:p-8 text-[#333] flex flex-col justify-center">
<h2 className="text-2xl md:text-4xl font-script mb-4 text-secondary font-bold whitespace-nowrap">
  Meet Gaurv Parmarthy
</h2>

          <p className="text-primary text-xl md:text-2xl font-semibold mb-5">
IIT Kharagpur alumnus, Founder –
PARAM, Ex-Founder Wiom (Tech
start-up)          </p>

          <p className="mb-4 text-[16px] text-lg md:text-xl leading-relaxed">
Hi, if you had met me 7 years ago, my life ticked most
boxes of being successful by the book –          </p>

          <ul className="space-y-2 mb-5 text-lg md:text-xl text-[15px]">
            <li className="flex items-center gap-2 text-black">Studied at India’s most prestigious institute</li>
            <li className="flex items-center gap-2 text-black">Cofounder at a well-funded tech start-up</li>
            <li className="flex items-center gap-2 text-black">Buzzing social and professional life</li>
                        <li className="flex items-center gap-2 text-black">Rewards and recognition</li>

          </ul>

          <p className="text-[15px] text-lg md:text-xl leading-relaxed whitespace-pre-line">
But despite the external success, I realized I was
struggling from inside.             <br />
I felt restless, drained,
purposeless, unhealthy. unfulfilled.            {!showMore && (
              <span
                onClick={() => setShowMore(true)}
                className="text-primary cursor-pointer ml-1 font-medium underline"
              >
                ...View more
              </span>
            )}
            {showMore && (
              <>
                <br />
I tried all the usual fixes - Gym. Self-help Books.
Motivation content. It helped for a while, but the
problems persisted.It’s only later that I discovered the real reason -{" "}
                <span className="font-semibold italic">Because I was not working at the root level.

Because I was missing the <span className=' text-[#578d48]'>Inner Alignment.</span> </span>
              </>
            )}
          </p>
        </div>
      </div>
    </div>
  


<section className="bg-white py-16 px-6 md:px-14 max-w-6xl mx-auto text-center">
  <h2 className="text-2xl md:text-4xl font-bold text-secondary mt-8 md:mt-10 mb-8 md:mb-14">
    What Do I Really Mean By “Inner Alignment”?
  </h2>

  <div className="space-y-6 text-gray-800 text-lg md:text-xl text-left mt-4">
    <p>We humans are pretty smart and have done a lot of amazing things.</p>
    <p>We’ve built insane machines, flown to space, connected the entire world through a screen.</p>

    <p>But when it comes to understanding our own inner world? Most of us still struggle.</p>
    
    <p>We struggle with thoughts that are out of our control.
    Emotions that feel too much.
    Habits we don’t like but keep repeating.
    Health issues, burnout, emptiness, relationship mess.
    And deep down, a sense of “What am I even doing?”</p>

    <p>We are not struggling because we’re weak or stupid.</p>
    <p>We are struggling because we’re disconnected.</p>

    <ul className="list-disc pl-6">
      <li>Disconnected from who we really are — our real nature, inner wisdom, inner strength.</li>
      <li>Disconnected from the natural rhythms — sleep, food, breath, rest.</li>
      <li>Conditioned by people around us — copying someone else’s life and dreams.</li>
      <li>Drowning in distraction — phones, reels, endless scrolling.</li>
      <li>Overstimulated emotionally — craving hits of dopamine and losing patience.</li>
      <li>Running after success, money, fame — without clarity of purpose and sense of meaning.</li>
    </ul>

    <p>We keep chasing things outside, never learning about things that really matter.</p>
<p>Things like…
</p>
    <ul className="list-disc pl-6">
      <li>How do I manage my emotions?</li>
      <li>How do I stay peaceful and joyful?</li>
      <li>How do I maintain my focus and energy?</li>
      <li>How do I deal with stress or anxiety?</li>
      <li>How do I feel healthier and strong?</li>
      <li>How do I build better relationships?</li>
      <li>And… What will make me feel truly happy and fulfilled?</li>
    </ul>

    <p>So what do we do? We find quick fixes - piecing it together through YouTube videos, podcasts, Insta reels…</p>
    <p>A little from here, a little from there — and nothing sticks.</p>

    <div className="border-l-4 border-secondary pl-4 text-primary italic">
      <p>
        It doesn’t work, because we’re not working at the root level. Because we are missing the <strong className='text-secondary'>Inner Alignment</strong>.
      </p>
    </div>

    <h3 className="text-2xl md:text-4xl font-bold text-secondary text-center mt-8 md:mt-14 mb-8 md:mb-14">The Truth Is…</h3>
    <p>You’re not lacking more information. Or more motivation.</p>
    <p>You’re lacking a fool-proof system which can support you.</p>
    <p>You need a system that guides and nurtures you holistically — not just superficially.</p>
    <p>You need a method - which works suitable for your life, dreams, and challenges.</p>
    <p>You need a space - conducive for experiencing something new.</p>

    <h3 className="text-2xl md:text-4xl font-bold text-secondary text-center mt-8 md:mt-14 mb-8 md:mb-14">
      Introducing: The Innergise Retreat in the Himalayas
    </h3>
    <p className='text-primary'><strong>4 Days to Pause, Realign, and Come Back to Yourself</strong></p>
    <p>This isn’t just a yoga trip.</p>
    <p>It’s not a detox spa thing either.</p>
    <p>It’s a reset for your whole system.</p>
    <p>We’ll work with the body, breath, food, emotions, thoughts — and go deep.</p>
    <p>The Innergise Retreat is built on an ancient framework that still works today:</p>
    <p>Vichar (Thoughts), Achar (Conduct), Vihar (Lifestyle), Aahar (Food) —</p>
    <p>We call it the Powerful VAVA framework.</p>
    <p>By the end, you won’t just feel better.</p>
    <p>You’ll be better — lighter, clearer, more rooted in who you truly are.</p>

<h3 className="text-2xl md:text-4xl font-bold text-secondary text-center mt-8 md:mt-14 mb-8 md:mb-14">
  Here’s What It Offers You
</h3>

<ul className="list-none pl-0 space-y-6">
  {[
    {
      title: "Prakriti Assessment:",
      desc: "Your Mind‑Body Blueprint — Figure out your mind-body type so you can eat, live, and move in sync with you.",
    },
    {
      title: "Daily Movement, Breathwork & Yoga Nidra:",
      desc: "Not tiring workouts — but mindful practices to recharge your system and calm your nerves.",
    },
    {
      title: "The SAMARA Technique:",
      desc: "A powerful process to decondition and rewire your mind for strength, growth, and happiness.",
    },
    {
      title: "Practical Tools from Vedanta + Positive Psychology:",
      desc: "Not abstract theory — real tools to transform your inner patterns and outlook.",
    },
    {
      title: "Sattvic Meals + Pure Himalayan Environment:",
      desc: "Delicious healthy food. Quiet space. Fresh mountain air. Exactly what your system needs.",
    },
    {
      title: "A Soul-nourishing Group Experience:",
      desc: "Fun-filled, engaging, and insightful games and activities with the tribe of like-hearted people.",
    },
  ].map((item, index) => (
    <li key={index} className="flex items-start space-x-2">
      <span className="text-xl mt-1">✅</span>
      <div>
        <strong className="block md:inline">{item.title}</strong>
        <span className="block md:inline">{item.desc}</span>
      </div>
    </li>
  ))}
</ul>

    <h3 className="text-2xl md:text-4xl font-bold text-secondary text-center mt-8 md:mt-14 mb-8 md:mb-14">This Is for You If…</h3>
<ul className="list-none pl-0  space-y-4">
  {[
    "You’re tired — mentally, emotionally, or spiritually",
    "You’ve tried everything, but nothing’s truly shifted",
    "You’re looking for a real boost to your health and joy",
    "You want to reconnect with your real self again",
    "You’re done with life’s auto-pilot and want to live with purpose",
  ].map((text, index) => (
    <li key={index} className="pt-4 first:pt-0">
      {text}
    </li>
  ))}
</ul>

<h3 className="text-2xl md:text-4xl font-bold text-secondary text-center mt-8 md:mt-14 mb-8 md:mb-14">
  Why Should You Trust This?
</h3>

<p>Being a scientific-minded person, I always tried to verify things with logical reasoning and personal experience.</p>

<p>So, when I tried the popular stuff to fix my health and happiness, it didn’t work because it was superficial and fragmented. It lacked real depth and holistic impact.</p>

<p>That’s when I found something that changed everything. Something that I once dismissed.</p>

<p>I came across Vedanta and Yogic science. In the Himalayas. At Sivananda Ashram.</p>

<p>I spent the next 5 years in the Himalayas. This is where I discovered Inner Alignment, Holistic Wellbeing, and Self Awareness.</p>

<p>This is where I acquired powerful practical tools, concepts, techniques, and more importantly a whole new mindset which transformed my life.</p>

<p>This motivated me to build <strong>PARAM</strong> — a platform for inner transformation and holistic wellbeing for aspiring people like you.</p>

<p><strong>INNERGISE</strong> retreat is designed to trigger that same transformation journey — in an easy, fun, and relatable way.</p>
    <h3 className="text-2xl md:text-4xl font-bold text-secondary text-center mt-8 md:mt-14 mb-8 md:mb-14">What Makes Innergise So Different?</h3>
    <p>It rewires your thoughts, energy, and habits — from within.</p>
    <p>After the program, you’ll leave with:</p>
<ul className="list-none pl-6 mt-3 space-y-4">
  <li>✨ More clarity</li>
  <li>🧠 More calm</li>
  <li>🔥 More focus</li>
  <li>💪 More energy</li>
  <li>🌿 And a personal system to live with — for life</li>
</ul>

    <p>And what can be a better place for this experience than the Himalayas?</p>

    <h3 className="text-2xl md:text-4xl font-bold text-secondary text-center mt-8 md:mt-14 mb-8 md:mb-14">Final Note from Gaurv</h3>
    <p>If you’re still reading, then something inside you is already saying “yes.”</p>
    <p>Yes to pausing and going deeper.</p>
    <p>Yes to choosing alignment over confusion.</p>
    <p>Yes to discovering and reconnecting with who you truly are.</p>
    <p>If that’s you, I look forward to meeting you in the Himalayas.</p>

    <div className="mt-10 md:p-5 text-center flex flex-col items-center">
            <BookingCTA timeLeft={timeLeft} setShowPopup={setShowPopup} />


      {showPopup && <PopupRegisterForm onClose={() => setShowPopup(false)} />}
    </div>
  </div>
</section>



<Timeline timeheading={timeheading} journey={journey} />
    <section className="bg-[#f5f7fb] py-12 px-4 text-center">
      <h2 className="text-2xl md:text-4xl font-bold text-secondary mb-4">
        Captured Moments from the <span className="text-primary">Himalayas</span>
      </h2>
      <p className="text-lg text-[#578d48] mb-10">
        Real people. Real moments. Real transformation.
      </p>

          <MediaShowcase
                mediaItems={accomodateItems} // Only images
                showVideo={false} // Disable videos
          
          /></section>
      <section className="py-20 px-6 text-center bg-accent">
  <h2 className="text-3xl md:text-4xl font-heading font-bold text-secondary mb-10">
    This Is Not Just a Vacation. It’s a Reset.
  </h2>

  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 max-w-6xl mx-auto">
    {resetHighlights.map((item, idx) => (
      <div
        key={idx}
        className="flex flex-col items-center bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all"
      >
        <div className="text-4xl mb-4">{item.icon}</div>
        <p className="text-lg font-semibold font-body text-primary">{item.text}</p>
      </div>
    ))}
  </div>
</section>

        <div className="container mx-auto px-4">
          <DynamicVideoCarousel
            heading="Impact Stories"
            videos={testimonalVideos}
            showNavigation
          />
        </div>
      <BookingCTA timeLeft={timeLeft} setShowPopup={setShowPopup} />
      {showPopup && <PopupRegisterForm onClose={() => setShowPopup(false)} />}
<section className="py-12 md:py-20 px-6 md:px-16 mt-4 md:mt-8 bg-accent">
  <div className="flex flex-col md:flex-row items-stretch gap-12 max-w-7xl mx-auto">
    
    {/* Left side image with controlled aspect ratio */}
    <div className="w-full md:w-1/2">
      <div className="h-full rounded-2xl shadow-lg overflow-hidden">
        <img
          src="assets/gp2.jpg"
          alt="What You're Getting"
          className="w-full h-full object-cover"
        />
      </div>
    </div>

    {/* Right side gift cards */}
    <div className="w-full md:w-1/2 flex flex-col justify-center px-4">
      <h2 className="text-3xl md:text-4xl font-heading font-bold text-secondary mb-6 text-center md:text-left">
        What You’re Getting When You Join <span className="text-primary">Innergise Retreat</span>
      </h2>

      <div className="space-y-5">
        {retreatGifts.map((gift, idx) => (
          <div
            key={idx}
            className="bg-white rounded-xl p-5 shadow-md flex flex-col items-center text-center md:flex-row md:items-start md:text-left"
          >
            {/* Left column: Emoji + Title inline */}
<div className="flex flex-col md:flex-row items-start md:items-center mb-2 md:mb-0">
  {/* Left column: emoji + title */}
  <div className="flex items-center mb-2 md:mb-0 md:mr-4 flex-1">
    <span className="text-2xl md:text-3xl mr-2">{gift.emoji}</span>
    <h3 className="text-lg font-bold text-secondary">{gift.title}</h3>
  </div>

  {/* Right column: description + worth */}
  <div className="flex flex-col md:flex-row justify-between flex-1">
    <p className="text-gray-700 text-sm font-body mb-2 md:mb-0">{gift.description}</p>
    <div className="mt-1 md:mt-0 md:text-right">
      <span className="bg-orange-500 text-white px-3 py-1 text-sm font-semibold rounded-lg inline-block">
        Worth {gift.value}
      </span>
    </div>
  </div>
</div>
          </div>
        ))}
      </div>
    </div>

  </div>
</section>

{/* Price Summary Section */}
<div className="bg-accent py-2 md:py-4 text-center px-2 md:px-8 -mt-4 md:mt-0">
  <h3 className="text-xl md:text-3xl font-bold text-secondary mb-2">
    Total Value:{' '}
    <span className="line-through text-black text-2xl md:text-3xl font-bold">₹42,499</span>
  </h3>
  <h2 className="text-2xl md:text-3xl font-extrabold text-primary mb-3">
    Today’s Offer: ₹23,599 Only
  </h2>
  <p className="text-md md:text-xl font-semibold text-[#d3005a]">
    💥 Save ₹18,900 + Instant Bonuses 
  </p>
</div>
    <div className="mt-5 md:p-5 text-center flex flex-col items-center">

      {/* Book Now Button */}
<div className="w-full flex justify-center ">
  <Button
    text="Book Now"
    variant="primary"
    size="md"
    onClick={() => setShowPopup(true)}
    className="min-w-[320px] md:min-w-[360px]"
  />
</div>

      {/* Countdown Timer */}
<div className="flex space-x-4 mt-6 mb-6">
  {["Days", "Hours", "Minutes", "Seconds"].map((label, i) => {
    const value = [timeLeft.days, timeLeft.hours, timeLeft.minutes, timeLeft.seconds][i];
    return (
      <div
        key={label}
        className="flex flex-col items-center justify-center min-w-[64px] md:min-w-[72px] bg-[#578d48] rounded-md px-2 py-1 md:px-3 md:py-2 shadow text-white font-bold"
      >
        <span className="text-xl md:text-2xl">{String(value).padStart(2, "0")}</span>
        <span className="text-xs">{label}</span>
      </div>
    );
  })}
</div>

      {/* Registration Popup */}
      {/* This is only handled outside this component via setShowPopup */}
    </div>
                        <FAQSection faqs={faqData} />


      {showPopup && <PopupRegisterForm onClose={() => setShowPopup(false)} />}


<div className="fixed bottom-0 left-0 w-full z-50 bg-primary text-white px-4 py-3 shadow-md">
  <div className="flex flex-col md:flex-row md:items-center md:justify-center md:space-x-6">
    <div className="flex flex-row justify-between items-center w-full md:w-auto text-sm md:text-base font-semibold">
      <p className="text-left md:text-center">
        Reserve your seat just in ₹2,499/-
      </p>
      <div className="ml-4 md:ml-0">
        <Button
          text="Book Now"
          variant="whitish"
          size="sm"
          className='"hover:animate-bounce"
'
          onClick={() => setShowPopup(true)}
        />
      </div>
    </div>
  </div>
</div>

      {showPopup && <PopupRegisterForm onClose={() => setShowPopup(false)} />}</div>

      </div>
  );
};

export default InnergiseLandingPage;
